export const acceptedImageFormats = ['png', 'jpeg', 'jpg', 'jfif', 'pjpeg', 'pjp'];